import { render, staticRenderFns } from "./UploadImgAndVideo.vue?vue&type=template&id=05e97817"
import script from "./UploadImgAndVideo.vue?vue&type=script&lang=js"
export * from "./UploadImgAndVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports